<template>
  <div class="body">
    <div class="grid container">
      <link rel="preconnect" href="https://fonts.googleapis.com">
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
      <link href="https://fonts.googleapis.com/css2?family=Spartan:wght@400;500;700&display=swap" rel="stylesheet">
      <Intro />
      <Ratings :ratings="ratings" />
      <Card :quotes="quotes" />
    </div>
  </div>
</template>

<script>
import Card from '../components/social-proof-section/Card.vue';
import Intro from '../components/social-proof-section/Intro.vue';
import Ratings from '../components/social-proof-section/Ratings.vue';

export default {
  name: 'SocialProof',
  components: {
    Card,
    Intro,
    Ratings,
  },
  data() {
    return {
      quotes: [
        {
          id: 1,
          name: 'Colton Smith',
          status: 'Verified Buyer',
          image_url: 'image-colton.jpg',
          text: `We needed the same printed design as the one we had ordered a week prior.Not only did they
                find the original order, but we also received it in time.Excellent!`,
        },
        {
          id: 2,
          name: 'Irene Roberts',
          status: 'Verified Buyer',
          image_url: 'image-irene.jpg',
          text: `Customer serviceis always excellent and very quick turn around.
                  Completely delighted with the simplicity of the purchase and the speed of delivery.`,
        },
        {
          id: 3,
          name: 'Anne Wallace',
          status: 'Verified Buyer',
          image_url: 'image-anne.jpg',
          text: `Put an order with this company and can only praise them for the very high standard.
                  Will definitely use them again and recommend them to everyone!`,
        },
      ],
      ratings: [
        { num: 5, text: 'Rated 5 Stars in Reviews' },
        { num: 5, text: 'Rated 5 Stars in Report Guru' },
        { num: 5, text: 'Rated 5 Stars in BestTech' },
      ],
    };
  },
};

</script>

<style src="../css/social-proof/global.css" scoped />
<style lang="scss" scoped>
  .body {
      background-image: url(../assets/sps/bg-pattern-top-mobile.svg);
      background-repeat: no-repeat;
      background-position: top left, bottom right;
      background-size: 100%;
      min-height: 100vh;

     @media (min-width: 50em) {
        background-image:
          url(../assets/sps/bg-pattern-top-desktop.svg),
          url(../assets/sps/bg-pattern-bottom-desktop.svg);
        background-size: 36%, 80%;
        height: 100vh;
        overflow: hidden;
      }
    }

  .container {
    --very-dark-magenta: hsl(300, 43%, 22%);
    --soft-pink: hsl(333, 80%, 67%);
    --dark-grayish-magenta: hsl(303, 10%, 53%);
    --light-grayish-magenta: hsl(300, 24%, 96%);
    --white: hsl(0, 0%, 100%);

    --border-radius: 0.5rem;
    --sm-spacer: 2rem;
    --bg-spacer: 4rem;

    --ff-default: 'Spartan', sans-serif;
    --fs-h1: 3rem;
    --fs-normal: 1.2rem;
    --fs-small: 1rem;
  }

  @media (min-width: 50em) {
    .grid {
      margin: 7rem auto;

      display: grid;
      gap: var(--sm-spacer);
      grid-template-columns: repeat(2, 1fr);
      grid-template-areas: "a b" "c c";
    }

    .cards {
      grid-area: c;
    }
  }
</style>
